'use es6';

import { setIn } from './update';
export var getHeader = function getHeader(name, responseOrOptions) {
  var headers = responseOrOptions.headers;

  if (!headers) {
    return undefined;
  }

  for (var header in headers) {
    if (headers.hasOwnProperty(header) && header.toLowerCase() === name.toLowerCase()) {
      return headers[header];
    }
  }

  return undefined;
};
export var setHeader = function setHeader(name, value, options) {
  var headers = options.headers;

  for (var header in headers) {
    if (headers.hasOwnProperty(header) && header.toLowerCase() === name.toLowerCase()) {
      return setIn(['headers', header], value)(options);
    }
  }

  return setIn(['headers', name], value)(options);
};